export enum actionTypes {
    REQUEST_DR_MAIL_TEMPLATES_LIST = "REQUEST_DR_MAIL_TEMPLATES_LIST",
    RECEIVE_DR_MAIL_TEMPLATES_LIST = "RECEIVE_DR_MAIL_TEMPLATES_LIST",
    COMPLETED_DR_MAIL_TEMPLATES = "COMPLETED_DR_MAIL_TEMPLATES",
    CREATE_DR_MAIL_TEMPLATE = "CREATE_DR_MAIL_TEMPLATE",
    UPDATE_DR_MAIL_TEMPLATE = "UPDATE_DR_MAIL_TEMPLATE",
    DELETE_DR_MAIL_TEMPLATE = "DELETE_DR_MAIL_TEMPLATE",
  }